import moment from "moment/moment";
import { Stack, Typography, lighten, Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

import { BG_COLORS, BORDER_COLORS, FONT_COLORS } from "../../../../constants";
import FilledIcon from "../../../../components/FIlledIcon";
import { TPaymentMethod } from "../../../../features/paymentMethods/paymentMethods.types";
import VisaIcon from "../../../../assets/card/visa.svg";
import MasterCardIcon from "../../../../assets/card/mastercard.svg";

type TPaymentMethodProps = {
  paymentMethod: TPaymentMethod;
};

const ICONS: Record<string, string> = {
  visa: VisaIcon,
  mastercard: MasterCardIcon,
};

export const PaymentMethod = ({ paymentMethod }: TPaymentMethodProps) => {
  const expirationDate = moment(
    `${paymentMethod.card.expMonth}/${paymentMethod.card.expYear}`,
    "MM/YYYY",
  ).format("YYYY/MM");

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      gap={3}
      height={90}
      px={3}
      py={2}
      border={
        paymentMethod.isDefault
          ? `1px solid ${BORDER_COLORS.info}`
          : `1px solid ${lighten(BORDER_COLORS.default, 0.5)}`
      }
      borderRadius={1}
      bgcolor={
        paymentMethod.isDefault
          ? lighten(BG_COLORS.primary, 0.95)
          : BG_COLORS.default
      }
    >
      <Stack flex={1} gap={0.5}>
        <Stack direction="row" alignItems="center" gap={1} height={24}>
          <Typography
            fontSize={14}
            fontWeight={600}
            color={FONT_COLORS.default}
            textTransform="capitalize"
          >
            {paymentMethod.card.brand}
          </Typography>
        </Stack>
        <Typography
          fontSize={12}
          fontWeight={500}
          color={FONT_COLORS.subheading}
        >
          **** **** **** {paymentMethod.card.last4}
        </Typography>
        <Typography
          fontSize={12}
          fontWeight={500}
          color={FONT_COLORS.subheading}
        >
          Expires on {expirationDate}
        </Typography>
      </Stack>
      <Stack
        justifyContent={paymentMethod.isDefault ? "space-between" : "flex-end"}
        alignItems="flex-end"
        height="100%"
      >
        {paymentMethod.isDefault && (
          <FilledIcon renderIcon={(props) => <CheckIcon {...props} />} />
        )}
        {ICONS[paymentMethod.card.brand] ? (
          <Stack height={28} width={28} justifyContent="flex-end">
            <img
              src={ICONS[paymentMethod.card.brand]}
              alt="Payment method icon"
              width="100%"
              height="auto"
            />
          </Stack>
        ) : (
          <Box />
        )}
      </Stack>
    </Stack>
  );
};
